import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './QuickViewSkeleton.css';

const QuickViewSkeleton: React.FC = () => (
  <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>

    {/* ── Header (gradient area) ── */}
    <div
      style={{
        background: "linear-gradient(90deg, #e8f5e9 0%, #f0f4ff 60%, #f8fafc 100%)",
        padding: "20px 20px 16px",
        borderRadius: "0 0 16px 16px",
        marginBottom: 4,
      }}
    >
      {/* close button placeholder */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Skeleton width={32} height={32} borderRadius={8} />
      </div>

      {/* Hero: avatar + name block */}
      <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 18 }}>
        {/* avatar with ring */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <Skeleton circle width={72} height={72} />
          <div style={{ position: "absolute", bottom: -4, right: -4 }}>
            <Skeleton circle width={28} height={28} />
          </div>
        </div>

        {/* name / designation / tags */}
        <div style={{ flex: 1 }}>
          <Skeleton width="60%" height={18} borderRadius={6} style={{ marginBottom: 6 }} />
          <Skeleton width="40%" height={13} borderRadius={6} style={{ marginBottom: 10 }} />
          <div style={{ display: "flex", gap: 8 }}>
            <Skeleton width={100} height={24} borderRadius={999} />
            <Skeleton width={70}  height={24} borderRadius={999} />
          </div>
        </div>
      </div>

      {/* Action buttons: Connect · Schedule · Message */}
      <div style={{ display: "flex", gap: 10 }}>
        <Skeleton width={100} height={36} borderRadius={999} />
        <Skeleton width={100} height={36} borderRadius={999} />
        <Skeleton width={100} height={36} borderRadius={999} />
      </div>
    </div>

    {/* ── Scrollable content ── */}
    <div style={{ flex: 1, overflowY: "auto", padding: "16px 20px" }}>

      {/* Stats row: Match · Distance · Mutual */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 10,
          marginBottom: 20,
        }}
      >
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            style={{
              background: "#f8fafc",
              borderRadius: 12,
              padding: "12px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Skeleton width={40} height={18} borderRadius={6} />
            <Skeleton width={50} height={12} borderRadius={6} />
          </div>
        ))}
      </div>

      {/* About section */}
      <div style={{ marginBottom: 20 }}>
        <Skeleton width={60} height={14} borderRadius={6} style={{ marginBottom: 8 }} />
        <Skeleton count={3} height={12} borderRadius={6} style={{ marginBottom: 4 }} />
        <Skeleton width="70%" height={12} borderRadius={6} />
      </div>

      {/* Skills section */}
      <div style={{ marginBottom: 20 }}>
        <Skeleton width={50} height={14} borderRadius={6} style={{ marginBottom: 10 }} />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {[80, 100, 70, 90, 60, 110].map((w, i) => (
            <Skeleton key={i} width={w} height={28} borderRadius={999} />
          ))}
        </div>
      </div>

      {/* Details section */}
      <div style={{ marginBottom: 20 }}>
        <Skeleton width={55} height={14} borderRadius={6} style={{ marginBottom: 10 }} />
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}
          >
            <Skeleton circle width={32} height={32} />
            <div style={{ flex: 1 }}>
              <Skeleton width="35%" height={11} borderRadius={6} style={{ marginBottom: 4 }} />
              <Skeleton width="60%" height={13} borderRadius={6} />
            </div>
          </div>
        ))}
      </div>

      {/* Attachments section */}
      <div>
        <Skeleton width={90} height={14} borderRadius={6} style={{ marginBottom: 10 }} />
        {[0, 1].map((i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              background: "#f8fafc",
              borderRadius: 10,
              padding: "10px 14px",
              marginBottom: 10,
            }}
          >
            <Skeleton width={36} height={36} borderRadius={8} />
            <div style={{ flex: 1 }}>
              <Skeleton width="50%" height={13} borderRadius={6} style={{ marginBottom: 4 }} />
              <Skeleton width="35%" height={11} borderRadius={6} />
            </div>
          </div>
        ))}

        {/* Full View button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
          <Skeleton width={100} height={34} borderRadius={999} />
        </div>
      </div>
    </div>
  </div>
);

export default QuickViewSkeleton;
